export interface IMenuOption {
  id: number;
  group: 'product' | 'all' | 'none';
  subgroup?: number;
  path?: string;
  label?: string;
  disabled?: boolean;
}

export interface IProductMenuOption {
  id: number;
  type: 'product' | 'tab';
  path?: string;
  label?: string;
  disabled?: boolean;
  group: string;
  pId?: number;
}
// Note: paths must match with paths on routes.ts

export class MenuOptions {
  private static readonly options: IMenuOption[] = [
    // ALL
    { id: 0, group: 'all', path: 'analysis-all', label: 'Analysis', disabled: true },
    { id: 1, group: 'all', path: 'backtest', label: 'Backtest Report' },
    { id: 2, group: 'all', path: 'concentration', label: 'Concentration Report', disabled: true },
    { id: 3, group: 'all', path: 'current-period', label: 'Current Month Summary', disabled: true },
    { id: 4, group: 'all', path: 'export-preview', label: `Export Preview: Calibrations Reports`, disabled: true },
    { id: 11, group: 'all', path: 'export-alm', label: `Export Preview: ALM Input Sheets`, disabled: true },
    { id: 10, group: 'all', path: 'recalculation-queue', label: 'Recalculation Queue' },

    // PRODUCT
    { id: 4, group: 'product', path: 'analysis', label: 'Analysis', subgroup: 1, disabled: true },

    { id: 5, group: 'product', path: 'dashboard', label: 'Dashboard', subgroup: 2 },
    { id: 6, group: 'product', path: 'product-detail', label: 'Product Detail', subgroup: 2 },

    { id: 7, group: 'product', path: 'beta', label: 'Beta Calibration', subgroup: 3 },
    { id: 8, group: 'product', path: 'decay', label: 'Decay Calibration', subgroup: 3 },
    { id: 9, group: 'product', path: 'stable-balance', label: 'Stable Balance Calibration', subgroup: 3 }
  ];

  public static All() {
    return MenuOptions.options.filter(options => options.group === 'all');
  }

  public static Product() {
    return MenuOptions.options.filter(options => options.group === 'product');
  }

  public static getOptionByLabel(label: string) {
    return MenuOptions.options.find(option => option.label === label);
  }

  public static getOptionByPath(path: string) {
    return MenuOptions.options.find(option => option.path === path);
  }
}
